import React, { PureComponent } from 'react';
import injectSheet from 'react-jss'
import LandingPageTitle from '../Widgets/LandingPageTitle'
import LookbookGallery from "./LookbookGallery"
import Author from "../Widgets/Author"
import RelatedLookbooks from "./RelatedLookbooks"
import {ArticleStructuredDataComponent} from "../StructuredDataComponent"
import findIndex from 'lodash/findIndex'
import sliceMapper from "../Article/sliceMapper"
import CenteredContainer from "../Widgets/CentredContentContainer"

class Lookbook extends PureComponent {

    render() {
        const {page} = this.props;
        const startOfGallery = findIndex(page.body, item => item.slice_type === 'lookbook_gallery_item');
        const bodyItemsBefore = sliceMapper( startOfGallery < 0 ? page.body : page.body.slice(0, startOfGallery), true );
        const bodyItemsAfter = sliceMapper(startOfGallery < 0 ? [] : page.body.slice(startOfGallery).filter( item => item.slice_type !== 'lookbook_gallery_item'), true );
        const galleryImages = page.body.filter( item => item.slice_type === 'lookbook_gallery_item')

        return (
            <CenteredContainer size="huge" extended={true}>
                <ArticleStructuredDataComponent article={page} />
                <LandingPageTitle title={page.title} subtitle={page.sub_title || 'Collection'} />
                {bodyItemsBefore}
                <LookbookGallery key={page.slug} containerSize="medium" galleryImages={galleryImages} />
                {bodyItemsAfter}
                <Author author={page.author} />
                <RelatedLookbooks related_articles={page.related_articles} />
            </CenteredContainer>
        );
    }
}

export default injectSheet(theme => ({

}))(Lookbook);



// WEBPACK FOOTER //
// ./src/components/Lookbook/index.js